import { UtilityLayerRenderer } from '@babylonjs/core/Rendering/utilityLayerRenderer';
import { Token } from '@kb3d/models/classes/token';
import { FeatureRenderer } from './feature';
import { SubdivisionFeature } from '@kb3d/models/classes/features/subdivision-feature';
import { SubdivisionGeometryProcessor } from './geometry-processor/subdivision-geometry';

export class SubdivisionFeatureRenderer extends FeatureRenderer<SubdivisionFeature, any> {
    modelToken = Token.SubdivisionFeature;
    previewLayer: UtilityLayerRenderer;
    processor = new SubdivisionGeometryProcessor(this.scene);

    constructor(viewer: any, scene: any) {
        super(viewer, scene);
        this.previewLayer = this.viewer.utilityLayer;
    }

    updateMeshGeometry(
        feature: SubdivisionFeature,
        vertexData: any,
        vertexDataChanges: Partial<any>
    ): Partial<any> {
        return {};
    }

    updateMeshGeometryCache(
        feature: SubdivisionFeature,
        vertexData: any,
        vertexDataChanges: Partial<any>
    ): Partial<any> {
        return {};
    }

    clearCache(): void { }
    updatePreviewMesh(feature: SubdivisionFeature): void { }
    update3dInternal(node: any): void { }
    delete3d(node: any): void { }
}



